import {applyMiddleware, compose, createStore} from "redux";

import {routerMiddleware} from "connected-react-router";
import {createBrowserHistory} from "history";
import thunkMiddleware from "redux-thunk";

import {reducers} from "./reducers/combinedReducers";

export const history = createBrowserHistory();

export default function configureStore(preloadedState) {
	return createStore(
		reducers(history), // root reducer with router state
		preloadedState,
		compose(
			applyMiddleware(
				routerMiddleware(history), // for dispatching history actions
				thunkMiddleware,
			),
		),
	);
}
